import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { guaranteeItems } from '../data/content';
export function Guarantee() {
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="guarantee-title" data-id="element-158" data-mp="223y639n82bl6">
      <div className="mx-auto max-w-3xl" data-id="element-159" data-mp="1x4l93w2mzo4v">
        <div className="rounded-3xl border-2 border-gold bg-cream p-6 text-center sm:p-10" data-id="element-160" data-mp="1x5msqoxpxiy7">
          <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-4 border-gold bg-navy text-gold-light" data-id="element-161" data-mp="19firupbwzxaw">
            <ShieldCheckIcon aria-hidden="true" className="h-7 w-7" data-id="element-162" data-mp="1j4k72damyant" />
            <span className="font-serif text-2xl font-extrabold leading-none" data-id="element-163" data-mp="1j5vaud42ziex">7</span>
            <span className="text-[9px] font-bold uppercase tracking-widest" data-id="element-164" data-mp="1ed28twzzyo6j">Days</span>
          </div>
          <p className="mt-5 text-xs font-bold uppercase tracking-[0.18em] text-gold" data-id="element-165" data-mp="qmommn43fjjv">My 7-day guarantee</p>
          <h2 id="guarantee-title" className="mt-2 font-serif text-[28px] font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-166" data-mp="lowjsy1wud0w">
            Try Oral Rehabilitation Blueprint™ Risk-Free for 7 Days
          </h2>
          <p className="mt-4 text-[16px] leading-relaxed text-ink-muted" data-id="element-167" data-mp="twi591fnvfmt">
            Open the system, review the materials, and decide whether the tools are useful for your workflow. For the first seven
            days you’ll be able to:
          </p>
          <ul className="mx-auto mt-5 grid max-w-xl gap-2 text-left sm:grid-cols-2" data-id="element-168" data-mp="61fh6voolg7e">
            {guaranteeItems.map(g => <li key={g} className="flex gap-2 text-[15px] text-navy" data-id="element-169" data-mp="b0a5gd5f3wyw">
                <CheckIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} data-id="element-170" data-mp="f0alu3c2ui8l" />
                {g}
              </li>)}
          </ul>
          <p className="mt-6 text-[16px] leading-relaxed text-ink-muted" data-id="element-171" data-mp="1qgr2u13a56xk">
            If within seven days you decide it isn’t right for you, simply contact us following the refund instructions provided
            at purchase and you’ll receive a <strong className="text-navy" data-id="element-172" data-mp="3rhf7qef9jvyh">100% refund</strong> in accordance with the guarantee terms.
          </p>
          <p className="mt-3 font-serif text-lg font-bold text-navy" data-id="element-173" data-mp="3ngvc5fac90eg">No complicated process. No unnecessary back-and-forth.</p>
        </div>

        <div className="mt-10" data-id="element-174" data-mp="coxbwtg5tzq">
          <CtaButton label="Try It Risk-Free for 7 Days" data-id="element-175" data-mp="dguvd6lu1sn" />
        </div>
      </div>
    </section>;
}